import type { Media, Post } from '@/payload-types'

/**
 * Forma mínima aceite pelo helper. `meta` interseta `Record<string, unknown>` para acomodar
 * tanto o `meta` SEO completo de `Post`/`CardPostData` (sem campo `image`) como o `meta` simplificado
 * do índice de pesquisa (`{ image }`). Sem a interseção, o TS rejeitaria o `meta` do Post por
 * «weak type» (objeto só com props opcionais e sem props em comum).
 */
type ListThumbnailDoc = {
  heroImage?: number | Media | null
  meta?: ({ image?: number | Media | null } & Record<string, unknown>) | null
}

/** Miniatura para listagens: `heroImage` ou, em índice de pesquisa, `meta.image`. */
export function getPostListThumbnail(doc: ListThumbnailDoc): Media | null {
  const heroImage = doc.heroImage
  if (heroImage && typeof heroImage === 'object') return heroImage

  const metaImage = doc.meta?.image
  if (metaImage && typeof metaImage === 'object') return metaImage

  return null
}
